import  { useState, useEffect } from "react";
import "./LanguagePopup.css";

const LanguagePopup = ({ isOpen, onClose, currentLanguage, onLanguageSelect }) => {
    const [selectedLang, setSelectedLang] = useState(currentLanguage);

    useEffect(() => {
        if (isOpen) {
            setSelectedLang(currentLanguage);
        }
    }, [isOpen, currentLanguage]);

    if (!isOpen) return null;

    const languages = [
        { code: "english", label: "English" },
        { code: "hindi", label: "हिंदी" },
        // { code: "marathi", label: "मराठी" },
        // { code: "gujarati", label: "ગુજરાતી" },
    ];

    const handleSelect = (code) => {
        setSelectedLang(code);
    };

    const handleDone = () => {
        onLanguageSelect(selectedLang);
        onClose();
    };

    return (
        <div className="language-popup-overlay" onClick={onClose}>
            <div className="language-popup-container" onClick={(e) => e.stopPropagation()}>
                <div className="language-popup-title">Select Language</div>
                <div className="language-options-list">
                    {languages.map((lang) => (
                        <div
                            key={lang.code}
                            className={`language-option ${selectedLang === lang.code ? "selected" : ""}`}
                            onClick={() => handleSelect(lang.code)}
                        >
                            <span className="language-name">{lang.label}</span>
                            {selectedLang === lang.code && <span className="language-check">✓</span>}
                        </div>
                    ))}
                </div>
                <button className="language-popup-done-btn" onClick={handleDone}>
                    Done
                </button>
            </div>
        </div>
    );
};

export default LanguagePopup;
